import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";
import {MsalAuthenticationTemplate, MsalProvider} from "@azure/msal-react";
import {InteractionType, PublicClientApplication} from "@azure/msal-browser";
import FinanceSuccess from "./Pages/FinanceSuccess";
import MsalGroup from "./MsalGroup";

// process.env['AZURE_CLIENT_ID']="7a2106e6-5d2d-49dd-9545-f480cb2861dd";
// process.env['AZURE_URL']="https://login.microsoftonline.com/78bd1c27-3871-40f2-b397-b39c6d40bf3c";

let adc = process.env.REACT_APP_CLIENT_ID;
let adu = "https://login.microsoftonline.com/78bd1c27-3871-40f2-b397-b39c6d40bf3c";

// MSAL configuration
const config = {
	auth: {
		clientId: adc,
		authority: adu,
		postLogoutRedirectUri: window.location.origin,
		redirectUri: window.location.origin,
		validateAuthority: true,
		navigateToLoginRequestUrl: true
	},
	cache: {
		cacheLocation: "sessionStorage", // This configures where your cache will be stored
		storeAuthStateInCookie: false,
	},
};

const authRequest = {
	scopes: ["openid", "profile"]
};


if (String(window.location.pathname).includes("/finance")) {
	ReactDOM.render(
		<BrowserRouter>
			<FinanceSuccess/>
		</BrowserRouter>,
		document.getElementById('root')
	)
}else{
	
	const pca = new PublicClientApplication(config);
	ReactDOM.render(
		<MsalProvider instance={pca}>
			<MsalAuthenticationTemplate
				interactionType={InteractionType.Redirect}
				authenticationRequest={authRequest}
				errorComponent={ErrorComponent}
				loadingComponent={LoadingComponent}
			>
				<BrowserRouter>
					<App/>
				</BrowserRouter>
			</MsalAuthenticationTemplate>
		</MsalProvider>,
		document.getElementById('root')
	);
}

function ErrorComponent({error}) {
	return <p>An Error Occurred: {error}</p>;
}

function LoadingComponent() {
	return <p>Authentication in progress...</p>;
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
